module.exports = __webpack_public_path__ + "static/creators-illustration-center-84972086e717580db339cd2080dd319f.webp";